/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DeleteProcessDocumentByFilenameHash$Params {

/**
 * the documentHash
 */
  documentHash: string;
}

export function deleteProcessDocumentByFilenameHash(http: HttpClient, rootUrl: string, params: DeleteProcessDocumentByFilenameHash$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteProcessDocumentByFilenameHash.PATH, 'delete');
  if (params) {
    rb.path('documentHash', params.documentHash, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deleteProcessDocumentByFilenameHash.PATH = '/processes/documents/{documentHash}';
